import { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { NsxFooter } from '@britishgasenergy/react-nucleus';

import { RouteScreen } from './RouteScreenRevamp';
import { useBeforeUnload } from 'hooks/useBeforeUnload';
import { RedirectComponent } from './RedirectComponent';
import { PageNotFound } from './PageNotFound';
import { useRoutes, UseRoutesReturnRevamp } from './useRoutes';
import { usePartner } from 'components/app/routes/usePartner';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { NsxHeader } from 'components/common/nsx-header/NsxHeader';

export const Routes = () => {
  const {
    routes,
    shouldShowPrompt,
    shouldRedirect
  } = useRoutes<UseRoutesReturnRevamp>();
  const { partnerPath } = usePartner();

  useBeforeUnload(shouldShowPrompt);

  return (
    <>
      <NsxHeader />

      <Switch>
        {routes.map((route, i) => (
          <Route key={i} path={route.path} exact>
            {() => {
              if (shouldRedirect) {
                return <RedirectComponent path={partnerPath} />;
              }

              return (
                <Suspense fallback={<NsStopgap />}>
                  <RouteScreen route={route} routes={routes} />
                </Suspense>
              );
            }}
          </Route>
        ))}
        <Route path="*" render={PageNotFound} />
      </Switch>
      <NsxFooter />
    </>
  );
};
